import { Navigate, Route, Routes } from 'react-router';
import { Trans } from '@lingui/react/macro';

import { PriceDisplayPreferences } from '@/routes/Profile/components/PriceDisplayPreferences/PriceDisplayPreferences';
import { InformationTab } from '@/routes/Profile/Tabs/InformationTab';
import { NotificationsTab } from '@/routes/Profile/Tabs/NotificationsTab/NotificationsTab';
import { useCurrentSession } from '@/services/auth';

import { SettingsSectionLayout } from '../components/Layout/Layout';

export const Account = () => {
  const { currentSession, setCurrentSession } = useCurrentSession();

  return (
    <SettingsSectionLayout
      title={<Trans id="settings-section.account">Account</Trans>}
      tabs={[
        { id: 'profile', label: <Trans id="settings-section.account.profile">Profile</Trans> },
        {
          id: 'preferences',
          label: <Trans id="settings-section.account.preferences">Preferences</Trans>,
        },
        {
          id: 'notifications',
          label: <Trans id="settings-section.account.notifications">Notifications</Trans>,
        },
      ]}
    >
      <Routes>
        <Route
          path="profile"
          element={
            <InformationTab
              currentSession={currentSession}
              setCurrentSession={setCurrentSession}
              showPreferences={false}
            />
          }
        />
        <Route path="preferences" element={<PriceDisplayPreferences showHeader={false} />} />
        <Route path="notifications" element={<NotificationsTab user={currentSession!} />} />
        <Route path="*" element={<Navigate to="/settings_beta/account/profile" replace />} />
      </Routes>
    </SettingsSectionLayout>
  );
};
